
import Vue from "vue";
import axios from "axios";
import PaginationBar from "@/components/PaginationBar.vue";

export default Vue.extend({
  components: { PaginationBar },
  data: () => ({
    allPapers: [] as any,
    papers: [] as any,
    page: 1,
    totalPage: 0,
    numInOnePage: 20,
  }),
  mounted() {
    this.fetchAll();
  },
  watch: {
    page() {
      this.updatePage();
      window.scrollTo(0, 0);
    },
  },
  methods: {
    fetchAll() {
      axios.get(Vue.prototype.apiUrl("publications")).then((response) => {
        this.allPapers = response.data || [];
        this.totalPage = Math.max(1, Math.ceil(this.allPapers.length / this.numInOnePage));
        this.page = Math.min(this.page, this.totalPage);
        this.updatePage();
      });
    },
    updatePage() {
      const start = (this.page - 1) * this.numInOnePage;
      const end = start + this.numInOnePage;
      this.papers = (this.allPapers || []).slice(start, end);
    },
  },
});
